
class InsuranceProduct extends HTMLElement {
    constructor() {
        super();
    }

    getSectionsToRender() {
        return [
            {
                id: "main-cart-items",
                section: document.getElementById("main-cart-items")?.dataset?.id || null,
                selector: ".js-contents",
            },
            {
                id: "main-cart-footer",
                section: document.getElementById("main-cart-footer")?.dataset?.id || null,
                selector: ".js-contents",
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section',
            },
            {
                id: 'CartDrawer',
                selector: '#CartDrawer',
                section: 'cart-drawer',
            }
        ];
    }

    renderSections(parsedState) {
        this.getSectionsToRender().forEach((section) => {
            if (!section.section) return;
            const sectionElement = document.getElementById(section.id);
            const elementToReplace =
                sectionElement && sectionElement.querySelector(section.selector)
                ? sectionElement.querySelector(section.selector)
                : sectionElement;
            if (elementToReplace) {
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    section.selector
                );
            }
        });
    }

    getSectionsUrl() {
        if (window.pageNumber) {
            return `${window.location.pathname}?page=${window.pageNumber}`;
        } else {
            return `${window.location.pathname}`;
        }
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }
}

if (!customElements.get("insurance-product-add")) {
    customElements.define(
        "insurance-product-add",
        class InsuranceProductAdd extends InsuranceProduct {
            constructor() {
                super();
                this.loader = this.querySelector('[data-asset="loading-spinner"]');
                this.label = this.querySelector('[data-asset="button-label"]');

                this.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.addInsuranceProduct(this.dataset.actualVariantId, this.dataset.insuranceVariantId, this.dataset.quantity)
                });
            }

            addInsuranceProduct(variantId, insuranceVariantId, quantity) {
                const body = JSON.stringify({
                    id: insuranceVariantId,
                    quantity: quantity,
                    properties: {
                        _associate_product: variantId
                    },
                    sections: this.getSectionsToRender().map((section) => section.section),
                    sections_url: this.getSectionsUrl(),
                });

                
                this.loader.classList.remove('hidden');
                this.label.classList.add('hidden');

                fetch(
                    `${routes.cart_add_url}`,
                    { ...fetchConfig(), ...{ body } }
                ).then((response) => {
                    return response.text();
                }).then((state) => {
                    const parsedState = JSON.parse(state);
                    this.renderSections(parsedState);
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: insuranceVariantId });
                }).catch((error) => {
                    console.error(error);
                    this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
                    const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
                    errors.textContent = window.cartStrings.error;
                }).finally(() => {
                    this.loader.classList.add('hidden');
                    this.label.classList.remove('hidden');

                    if (typeof window.freeSampleInit === "function") {
                        window.freeSampleInit();
                    }
                });
            }
        }
    )
}

if (!customElements.get("insurance-product-remove")) {
    customElements.define(
        "insurance-product-remove",
        class InsuranceProductRemove extends InsuranceProduct {
            constructor() {
                super();

                this.addEventListener('click', (event) => {
                    event.preventDefault();
                    if (this.dataset.index) {
                        event.currentTarget.closest('[data-asset="added-insurance-item"]').classList.add('updating');
                        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
                        cartItems.updateQuantity(this.dataset.index, 0);
                    } else {
                        event.currentTarget.closest('[data-asset="insurance-item"]').classList.add('hidden');
                    }
                });
            }
        }
    )
}